import { Routes, Route, useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { globalContext } from 'context/global';
import { NotFound } from 'pages/NotFound';
import { useDispatch, useSelector } from 'react-redux';
import { getContainerData } from 'store/modules/containerContext/actions';
import { ApplicationState } from 'store/store.inteface';
import { getRoleList } from 'store/modules/roles/actions';
import { StoreListContext } from 'context/StoreListContext';
import { getStoreData } from 'store/modules/storesContext/actions';
import { ROUTES } from './data';

interface RoutesProps {
  path?: string;
}

export const RoutesComponent = (props: RoutesProps): JSX.Element => {
  const { path = '' } = props;
  const { containerContext } = useContext(globalContext);
  const franchises = useContext(StoreListContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { rolesList } = useSelector((state: ApplicationState) => state.roles);

  useEffect(() => {
    dispatch(getContainerData(containerContext));
    dispatch(getRoleList());
  }, [dispatch, containerContext, franchises]);

  useEffect(() => {
    if (franchises.stores) {
      dispatch(getStoreData(franchises));
    }
  }, [dispatch, franchises]);

  const routes = ROUTES.filter(route =>
    route.roles.some(role => rolesList.includes(role)),
  );

  useEffect(() => {
    if (
      rolesList.length === 1 &&
      rolesList[0] === 'PS_FRANQUEADO_AERO_CERTIFICADO'
    ) {
      navigate(`${path}/certificates`);
    }
  }, [rolesList, path]);

  if (routes.length === 0) {
    return <p>Carregando...</p>;
  }

  return (
    <Routes>
      {routes.map((route: any) => {
        return (
          <Route
            key={route.path}
            path={`${path}${route.path}`}
            element={<route.component />}
          />
        );
      })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default RoutesComponent;
